import {h, Component} from 'preact';
import {connect} from "react-redux";
import reduce from "./reducers";
import * as actions from "./actions";
import store from './store';

export default @connect(reduce, actions)
class MainNotification extends Component {

  hide() {
    store.dispatch(actions.setMainNotificationMessage(""));
  }

  render(props, state) {
    return props.mainNotificationMessage ? <div className={"main-notification"}>
      <h3>{props.mainNotificationMessage}</h3>
      <button onClick={this.hide}>✕</button>
    </div> : null;
  }
}
